import React, { memo, forwardRef, useImperativeHandle, useState } from 'react';
import { TextFieldDate } from '../../components';
import { convertDateToString, convertToDate } from '../../utilitys/date';
import {
  HandleContractMetaDataChild,
  ResultContractMetaDataChild,
  TypeControl,
} from './types';

interface ITextFieldMemoProps {
  ref: any;
  id: number;
  label?: string;
  isRequired?: boolean;
  error?: string;
  value?: string;
  type?: string;
  autoFocus?: boolean;
  isOutlined?: boolean;
}

const DateTextBoxMemo = memo(
  forwardRef(
    (
      props: ITextFieldMemoProps,
      ref: React.Ref<HandleContractMetaDataChild | undefined>
    ) => {
      const { isRequired,  label, value, error, autoFocus, id, isOutlined } = props;
      const [valueLocal, setValueLocal] = useState<string>(value ? value : convertDateToString(new Date()));

      const onChange = (value: string) => {
        setValueLocal(value);
      };

      useImperativeHandle(ref, () => ({
        getData() {
          return {
            id,
            value: valueLocal,
            text: '',
            typeElement: TypeControl.text,
            label: label
          } as ResultContractMetaDataChild;
        },
      }));
      return (
        <TextFieldDate
          isOutlined={isOutlined}
          isRequired={isRequired}
          label={label || ''}
          value={convertToDate(valueLocal)}
          error={error}
          autoFocus={autoFocus}
          onChangeValueFormatISO={onChange}
        />
      );
    }
  )
);

export default DateTextBoxMemo;
